<div id="loader-wrapper">
  <div id="logoload"></div>
  <div id="loader"></div>
  <div class="loader-section section-left"></div>
  <div class="loader-section section-right"></div>
</div>
